import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { lazyBgDirective } from '../../directives/lazy-bg.directive';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { IFooterBlok } from './footer.model';
import { NgClass } from '@angular/common';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { TariffStore } from '../../../../tariff';
import { ImageComponent, IImageBlock } from '@seven1/angular-storyblok-components/image';

@Component({
    selector: 'app-footer',
    imports: [ImageComponent, lazyBgDirective, NgClass, CmsComponent],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'app-footer',
        '[class]': 'getDisplayClasses()',
    },
})
export class FooterComponent {
    private _tailwind = inject(TailwindService);
    tariff = inject(TariffStore);

    block = input.required<IFooterBlok>();

    getAllClasses = computed<string[]>(() => {
        const block = this.block();
        return [
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getBackgroundColorClasses(block),
            //     this.classes.getBackgroundSizeClass(this.backgroundSize()),
            //     this.classes.getGradientClassesFunction({
            //       gradientDirection: this.gradientDirection(),
            //       gradientDirectionTablet: this.gradientDirectionTablet(),
            //       gradientDirectionDesktop: this.gradientDirectionDesktop(),
            //       gradientColor: this.gradientColor(),
            //     }),
            //     this.classes.getBackgroundPositionClassFunction({
            //       bgPosition: this.bgPosition(),
            //       bgPositionTablet: this.bgPositionTablet(),
            //       bgPositionDesktop: this.bgPositionDesktop(),
            //     }),
        ];
    });

    getDisplayClasses = computed<string[]>(() => {
        return this._tailwind.getDisplayClasses(this.block());
    });

    public imageBlok = computed<IImageBlock | null>(() => {
        const blok = this.block();
        if (!blok.imageData?.length) {
            return null;
        }
        return {
            marginX: 'auto',
            maxWidth: blok.imageFixedWidth,
            maxWidthTablet: blok.imageFixedWidthTablet,
            maxWidthDesktop: blok.imageFixedWidthDesktop,
            asset: blok.imageData[0],
            lazyLoad: true,
            marginBottom: '3xl',
        };
    });
}
